<template>
  <!-- <MenuBar /> -->
  <ConfirmModal
    :popup="popup"
    @executePrimaryAction="handlePrimaryAction"
    ref="openModalBox"
  />
  <div v-if="showPopup">
    <PopupYAML
      :popup="popupData"
      :projectName="this.projectName"
      :setShowPop="setShowPop"
      :popupCommonData="this.popupCommonData"
      :loading="popUpLoading"
      :fileData="popupFileData"
      @popupRequestId="viewYAMLFile"
    />
  </div>
  <div v-if="showCalcPopup">
    <CalculateComplexityPopup
      :title="popupData.viewTitle"
      :project-param-id="projectParamId"
      @close="showCalcPopup = false"
      @reloadData="search"
      @openModal="openModalFromCalc"
      ref="removeRowRef"
    />
  </div>
  <TransformationFactoryPopup
    v-show="showTransformationFactoryPopup"
    @close="showTransformationFactoryPopup = false"
    @confirm="handleTransformationFactoryChoice"
  />
  <!-- Use Case Details Popup -->
  <div
    v-if="showUseCasePopup"
    class="modal fade show"
    style="display: block; background-color: rgba(0, 0, 0, 0.5);backdrop-filter:blur(8px);"
    tabindex="-1"
    @click.self="showUseCasePopup = false"
    role="dialog"
    aria-modal="true"
    aria-labelledby="useCaseModalTitle"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="useCaseModalTitle">Use Case Details</h5>
          <button
            type="button"
            class="btn-close"
            @click="showUseCasePopup = false"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">Use Case</th>
                  <th scope="col">usecaseIds</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!useCaseData || useCaseData.length === 0">
                  <td colspan="2" class="text-center">No use cases found.</td>
                </tr>
                <tr v-else v-for="(item, index) in useCaseData" :key="index">
                  <td>{{ item.useCase }}</td>
                  <td>{{ item.usecaseIds }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isGridVisible" class="modern-container">
    <div class="table-wrapper">
      <!-- Modern Filter Bar -->
      <div class="modern-filter-bar">
        <div class="filter-controls">
          <!-- Manage Columns -->
          <div class="dropdown">
            <button class="filter-btn" type="button" data-bs-toggle="dropdown">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                style="margin-right: 6px"
              >
                <rect
                  x="2"
                  y="2"
                  width="5"
                  height="5"
                  rx="1"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <rect
                  x="9"
                  y="2"
                  width="5"
                  height="5"
                  rx="1"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <rect
                  x="2"
                  y="9"
                  width="5"
                  height="5"
                  rx="1"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <rect
                  x="9"
                  y="9"
                  width="5"
                  height="5"
                  rx="1"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
              </svg>
              <span>Manage Columns</span>
            </button>
            <ul class="dropdown-menu modern-dropdown">
              <li>
                <a class="dropdown-item" href="#">
                  <label class="modern-checkbox-label">
                    <input
                      type="checkbox"
                      :value="'*'"
                      v-model="selectedColumns"
                      @change="handleColumnChange('*')"
                    />
                    <span>Select All</span>
                  </label>
                </a>
              </li>
              <hr class="dropdown-divider" />
              <li v-for="(column, index) in tableConfigs" :key="index">
                <a class="dropdown-item" href="#">
                  <label class="modern-checkbox-label">
                    <input
                      type="checkbox"
                      :value="column.name"
                      :disabled="column.checked"
                      v-model="selectedColumns"
                      @change="handleColumnChange(column.name)"
                    />
                    <span>{{ column.label }}</span>
                  </label>
                </a>
              </li>
            </ul>
          </div>

          <!-- Status Filter -->
          <div v-if="tableProps.type == 'users'" class="dropdown">
            <button class="filter-btn" type="button" data-bs-toggle="dropdown">
              <span>State</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                style="margin-left: 4px"
              >
                <path
                  d="M3 4.5L6 7.5L9 4.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <ul class="dropdown-menu modern-dropdown">
              <li>
                <a class="dropdown-item" href="#">
                  <label class="modern-checkbox-label">
                    <input
                      type="checkbox"
                      :value="'*'"
                      v-model="stateFilter"
                      @change="handleStateChange('*')"
                    />
                    <span>Select All</span>
                  </label>
                </a>
              </li>
              <hr class="dropdown-divider" />
              <li v-for="(status, name) in states" :key="name">
                <a class="dropdown-item" href="#">
                  <label class="modern-checkbox-label">
                    <input
                      type="checkbox"
                      :value="status.name"
                      v-model="stateFilter"
                      @change="handleStateChange(status.name)"
                    />
                    <span>{{ status.label }}</span>
                  </label>
                </a>
              </li>
            </ul>
          </div>
          <div v-else class="dropdown">
            <button class="filter-btn" type="button" data-bs-toggle="dropdown">
              <span>Status</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                style="margin-left: 4px"
              >
                <path
                  d="M3 4.5L6 7.5L9 4.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <ul class="dropdown-menu modern-dropdown">
              <li>
                <a class="dropdown-item" href="#">
                  <label class="modern-checkbox-label">
                    <input
                      type="checkbox"
                      :value="'*'"
                      v-model="selectedFilter"
                      @change="handleStatusChange('*')"
                    />
                    <span>Select All</span>
                  </label>
                </a>
              </li>
              <hr class="dropdown-divider" />
              <li v-for="(status, name) in this.$statuses" :key="name">
                <a class="dropdown-item" href="#">
                  <label class="modern-checkbox-label">
                    <input
                      type="checkbox"
                      :value="status.name"
                      v-model="selectedFilter"
                      @change="handleStatusChange(status.name)"
                    />
                    <span>{{ status.label }}</span>
                  </label>
                </a>
              </li>
            </ul>
          </div>

          <div class="search-bar-group d-flex align-items-center gap-2">
            <!-- Category Dropdown -->
            <div class="dropdown">
              <button
                class="btn filter-dropdown dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ searchConcept }}
              </button>

              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item mt-1"
                    href="#"
                    @click="setSearchFilter('All Categories')"
                  >
                    All Categories
                  </a>
                </li>
                <hr class="dropdown-divider" />
                <li
                  v-for="(searchColumns, index) in columns.search"
                  :key="index"
                >
                  <a
                    class="dropdown-item mt-1"
                    href="#"
                    @click="setSearchFilter(searchColumns)"
                  >
                    {{ searchColumns.label }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- Search Icon Input -->
            <div class="search-container">
              <svg
                class="search-icon"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M15 15L11.5 11.5"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              <input
                id="searchBar"
                class="modern-search-input"
                v-model="searchQuery"
                @input="handleInputs"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
            </div>

            <!-- Search Button -->
            <button
              class="btn btn-outline-dark search-btn"
              @click="searchWithQuery"
            >
              Search
            </button>

            <!-- Clear Filter Icon -->
            <button
              class="icon-btn"
              @click="clearFilters"
              v-tooltip="'Clear Filters'"
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M2 4.5H16M4 9H14M7 13.5H11"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </button>
          </div>
        </div>

       
<div class="action-buttons">
  <button
    class="action-icon-btn reload-btn"
    type="button"
    @click="searchWithQuery()"
    v-tooltip="'Reload'"
    aria-label="Reload"
  >
    <i class="fas fa-sync-alt"></i>
  </button>
  <button
    v-if="tableProps.actions && tableProps.actions.download"
    class="action-icon-btn download-btn"
    @click="bulkDownload(selectedReqsForBulkOps)"
    :disabled="selectedReqsForBulkOps.length === 0"
    v-tooltip="getTooltipText(tableProps.actions.download.label)"
  >
    <i v-if="tableProps.type === type.DOWNLOADS" class="fas fa-download"></i>
    <i v-else class="fas fa-cloud-download"></i>
  </button>

 

  <button
    v-if="tableProps.actions && tableProps.actions.delete"
    class="action-icon-btn delete-btn"
    @click="bulkDelete(selectedReqsForBulkOps)"
    :disabled="selectedReqsForBulkOps.length === 0"
    v-tooltip="getTooltipText(tableProps.actions.delete.label)"
  >
    <i class="fas fa-trash"></i>
  </button>

  <button
    v-if="tableProps.actions && tableProps.actions.view"
    class="action-icon-btn eye-btn"
    @click="bulkViewYAMLFile(selectedReqsForBulkOps)"
    :disabled="selectedReqsForBulkOps.length === 0"
    v-tooltip="getTooltipText(tableProps.actions.view.label)"
  >
    <i class="fas fa-eye"></i>
  </button>

  <button
    v-if="tableProps.actions && tableProps.actions.viewPopup"
    type="button"
    class="btn-view action-icon-btn eye-btn"
    @click="toggleTabs"
    :disabled="selectedReqsForBulkOps.length === 0"
    v-tooltip="getTooltipText(tableProps.actions.viewPopup.label)"
  >
    <i class="fas fa-eye"></i>
  </button>

  <button
    v-if="tableProps.actions && tableProps.actions.calculate"
    class="action-icon-btn calculator-btn"
    @click="calculateComplexity()"
    :disabled="selectedReqsForBulkOps.length === 0"
    v-tooltip="getTooltipText(tableProps.actions.calculate.label)"
  >
    <i class="fas fa-calculator"></i>
  </button>

  <button
    v-if="tableProps.actions && tableProps.actions.libarydownload"
    type="button"
    class="cloud-download action-icon-btn zip-btn"
    @click="connectorLibrary()"
    :disabled="selectedReqsForBulkOps.length === 0"
    v-tooltip="getTooltipText(tableProps.actions.libarydownload.label)"
  >
    <i class="fa-solid fa-file-zipper"></i>
  </button>

  <button
    v-if="tableProps.actions && tableProps.actions.xslDiff"
    type="button"
    class="btn-show-difference action-icon-btn compare-btn"
    @click="xslShowDiff(selectedReqsForBulkOps)"
    :disabled="selectedReqsForBulkOps.length === 0"
    v-tooltip="getTooltipText(tableProps.actions.xslDiff.label)"
  >
    <i class="fa-solid fa-code-compare"></i>
  </button>

  <button
    v-if="tableProps.actions && tableProps.actions.xmlDiff"
    type="button"
    class="btn-show-difference action-icon-btn compare-btn"
    @click="xmlShowDiff(selectedReqsForBulkOps)"
    :disabled="selectedReqsForBulkOps.length === 0"
    v-tooltip="getTooltipText(tableProps.actions.xmlDiff.label)"
  >
    <i class="fa-solid fa-code-compare"></i>
  </button>

  <button
    v-if="tableProps.actions && tableProps.actions.restore"
    type="button"
    class="btn-restore action-icon-btn restore-btn"
    @click="restore(tableProps.type, selectedReqsForBulkOps)"
    :disabled="selectedReqsForBulkOps.length === 0"
    v-tooltip="getTooltipText(tableProps.actions.restore.label)"
  >
    <i class="fa-solid fa-rotate-right"></i>
  </button>

  <!-- <button
    v-if="tableProps.actions && tableProps.actions.generate"
    type="button"
    class="btn-generate action-icon-btn"
    @click="generateOrchestrationConfig(selectedReqsForBulkOps)"
    :disabled="selectedReqsForBulkOps.length === 0"
    v-tooltip="getTooltipText(tableProps.actions.generate.label)"
  >
    <i class="fa-solid fa-recycle"></i>
  </button> -->
</div>

      </div>

      <Loading v-if="loading" />

      <!-- Modern Table -->
      <div
        v-else
        class="modern-table-container"
        :class="{ 'taller-height': isRootRoute }"
      >
        <table ref="requestTable" class="modern-table" @click.stop>
          <thead>
            <tr>
              <th v-if="isMultiSelectionAllowed" class="checkbox-column">
                <input
                  type="checkbox"
                  v-model="selectAllCheckboxes"
                  @change="toggleSelectAllCheckboxes"
                  class="modern-checkbox"
                />
              </th>
              <th
                v-for="(header, index) in selectedConfigs"
                :key="header.name"
                @mouseover="hoveredColumn = header.name"
                @mouseleave="hoveredColumn = ''"
                :class="{ sortable: isSortable(header) }"
                @click="isSortable(header) ? sort(header, index) : null"
              >
                <div class="th-content">
                  <span>{{ header.label }}</span>
                  <div v-if="isSortable(header)" class="sort-icon">
                    <svg
                      v-if="sortColumn === header.name"
                      width="20"
                      height="20"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path
                        v-if="isDescending"
                        d="M6 10L2 6H10L6 10Z"
                        fill="currentColor"
                      />
                      <path v-else d="M6 2L10 6H2L6 2Z" fill="currentColor" />
                    </svg>
                    <svg
                      v-else-if="hoveredColumn === header.name"
                      width="20"
                      height="20"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path d="M6 2L10 6H2L6 2Z" fill="#D0D5DD" />
                    </svg>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="noRecordFound">
              <td
                class="no-records"
                :colspan="
                  selectedConfigs.length + (isMultiSelectionAllowed ? 1 : 0)
                "
              >
                <div class="no-records-content">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <circle
                      cx="24"
                      cy="24"
                      r="20"
                      stroke="#E4E7EC"
                      stroke-width="2"
                    />
                    <path
                      d="M24 14V26M24 32V34"
                      stroke="#98A2B3"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                  <p>No records found</p>
                </div>
              </td>
            </tr>
            <tr
              v-else-if="reportTransactions && reportTransactions.transactions"
              v-for="(transaction, index) in reportTransactions.transactions"
              :key="getUniqueIDValue(transaction)"
              @click="
                handleRowClick($event, getUniqueIDValue(transaction), index)
              "
              :class="{
                'selected-row': effectiveSelections.includes(
                  getUniqueIDValue(transaction)
                ),
              }"
            >
              <td v-if="isMultiSelectionAllowed" class="checkbox-column">
                <input
                  type="checkbox"
                  :checked="
                    effectiveSelections.includes(getUniqueIDValue(transaction))
                  "
                  @click.stop="collateRequestIDs(getUniqueIDValue(transaction))"
                  class="modern-checkbox"
                />
              </td>

              <td
                v-for="column in selectedConfigs"
                :key="column.name"
                :style="getTextAlignmentStyle(transaction, column)"
              >
                <template v-if="column.name === 'accelatorStatus'">
                  <div class="status-badges">
                    <span
                      v-for="status in getStatusColumns(transaction)"
                      :key="status.accuracy"
                      class="status-badge"
                      v-tooltip="`${status.name} (${status.accuracyValue}%)`"
                    >
                      <!-- Circular Progress Ring + Larger Icon -->
                      <!-- <svg
                        class="progress-ring"
                        width="45"
                        height="45"
                        viewBox="0 0 40 40"
                      >
                   
                        <circle
                          class="ring-bg"
                          cx="20"
                          cy="20"
                          r="18"
                          stroke="#E4E7EC"
                          stroke-width="3"
                          fill="none"
                        />

                   
                        <circle
                          class="ring-progress"
                          :class="status.cssClass"
                          cx="20"
                          cy="20"
                          r="18"
                          stroke-width="3"
                          fill="none"
                  :stroke-dasharray="'113.1, 113.1'"

                        :stroke-dashoffset="(113.1 * (100 - status.accuracyValue)) / 100"

                          stroke-linecap="round"
                          transform="rotate(-90 20 20)"
                        />
                      </svg> -->

                      <svg class="progress-ring" viewBox="0 0 36 36">
                        <path
                          class="ring-bg"
                          d="M18 2.0845
                                     a 15.9155 15.9155 0 0 1 0 31.831 
                                     a 15.9155 15.9155 0 0 1 0 -31.831"
                          cx="20"
                          cy="20"
                          r="18"
                          stroke="#E4E7EC"
                          stroke-width="3"
                          fill="none"
                        />
                        <path
                          class="ring-progress"
                          :class="status.cssClass"
                          :stroke-dasharray="status.strokeDasharray"
                          d="M18 2.0845
                                     a 15.9155 15.9155 0 0 1 0 31.831
                                     a 15.9155 15.9155 0 0 1 0 -31.831"
                          cx="20"
                          cy="20"
                          r="18"
                          stroke-width="3"
                          fill="none"
                        />
                        <path
                          class="ring-border"
                          :class="status.cssClass"
                          d="M18 2.0845
                                     a 15.9155 15.9155 0 0 1 0 31.831 
                                     a 15.9155 15.9155 0 0 1 0 -31.831"
                          cx="20"
                          cy="20"
                          r="30"
                          fill="none"
                        />
                      </svg>

                      <!-- Larger Icon (24px) -->
                      <a
                        :href="getStatusRouteUrl(transaction, status)"
                        target="_blank"
                        rel="noopener noreferrer"
                        @click.prevent="
                          handleStatusIconClick(transaction, status)
                        "
                        class="status-icon-link"
                      >
                        <img
                          :src="status.icon"
                          alt="status"
                          class="status-icon-large"
                          :class="{
                            'not-applicable':
                              status.statusValue === 'Not Applicable',
                            failed: status.statusValue === 'Failed',
                            'in-progress': status.statusValue === 'In Progress',
                          }"
                        />
                      </a>
                    </span>
                  </div>
                </template>

                <template v-else-if="checkIfActionable(transaction, column)">
                  <a
                    v-tooltip="computeAccuracy(transaction, column)"
                    :class="[
                      'cell-link',
                      getStylesForStatus(
                        transaction,
                        column,
                        (isActionable = true)
                      ),
                    ]"
                    @click="handleActionableColumns(transaction, column)"
                  >
                    {{ getTableData(transaction, column) }}
                  </a>
                </template>

                <template v-else-if="checkIfDateColumn(column)">
                  <div
                    class="cell-date"
                    v-tooltip="computeDateAndTimestamp(transaction, column)"
                  >
                    {{ getTableData(transaction, column) }}
                  </div>
                </template>

                <template v-else-if="checkIfEditable(column)">
                  <div
                    :class="[
                      getStylesForStatus(
                        transaction,
                        column,
                        (isActionable = false)
                      ),
                    ]"
                  >
                    <select
                      v-if="isEditing(getUniqueIDValue(transaction), column)"
                      v-model="transaction[column.name]"
                      @change="trackChanges(transaction, column)"
                      class="modern-select"
                    >
                      <option
                        class="modern-option"
                        v-for="option in column.dropdownOptions"
                        :key="resolveDropDownSelectionKey(option, column)"
                        :value="resolveDropDownSelectionKey(option, column)"
                      >
                        {{ option }}
                      </option>
                    </select>
                    <div v-else class="editable-cell">
                      {{ getTableData(transaction, column) }}
                      <svg
                        @click="startEditing(transaction, column)"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="edit-icon"
                        fill="none"
                      >
                        <path
                          d="M4 20h4l10.293-10.293a1 1 0 0 0 0-1.414l-2.586-2.586a1 1 0 0 0-1.414 0L4 16v4z"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14 6l4 4"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div
                    v-tooltip="computeAccuracy(transaction, column)"
                    :style="getTextOverflowStyle(transaction, column)"
                    :class="[
                      'cell-text',
                      getStylesForStatus(
                        transaction,
                        column,
                        (isActionable = false)
                      ),
                      getSingleRecordCenterClass(transaction, column),
                    ]"
                    @mouseenter="
                      handleMouseEnterForEllipsedText(
                        $event,
                        transaction,
                        column
                      )
                    "
                    @mouseleave="hidleEllipsedTextTooltip($event)"
                  >
                    {{ getTableData(transaction, column) }}
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="modern-pagination" v-if="!noRecordFound">
        <Pagination
          :totalPages="totalPages"
          :perPage="pageSize"
          :currentPage="currentPage"
          :totalRecords="totalRecords"
          @pagechanged="onPageChange"
          @recordCount="onRecordChange"
          @clearSelection="handleClearSelection"
        />
      </div>
    </div>
  </div>
  <FooterView />
</template>

<script>
import Loading from "../Loading.vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { redirect } from "@/utils/routerUtils.js";
import { changeFileExtension } from "@/utils/util.js";
import {
  action,
  actionLabel,
  elementsToRemoveFromArray,
  invalidBEColumns,
  supportingColumns,
  CONVERSION_STATUS,
  STATUS_COLUMNS,
  DATE_COLUMNS,
  ACCURACY_COLUMNS_STATUS_MAP,
  pageViews,
  type,
  user,
  api_mode,
  GRID_ACTION_DATA_ELEMENTS,
  ROUTER_PARAMS_GRID_FILTER_MAP,
  role,
  EDITABLE_GRID_CHANGES_COLUMNS,
  EDITABLE_GRID_ACTIONS,
} from "../../utils/util.js";
import ConfirmModal from "../ConfirmModal.vue";
import { useSortStore, useTableColumnStore } from "../../store/sort.js";
import { usePaginationStore } from "../../store/paginationStore.js";
import { getCookie } from "../../store/cookie.js";
import { useUploadStore } from "../../store/fileUpload.js";
import { makeOpearationRequest, getTitle } from "@/services/apiServices";
import {
  getSessionItem,
  setSessionItem,
  removeSessionItem,
} from "../../store/session.js";
import { mock_response } from "../../utils/mock.js";
import PopupYAML from "../PopupYAML.vue";
import Pagination from "../Pagination.vue";
import CalculateComplexityPopup from "../CalculateComplexityPopup.vue";
import TransformationFactoryPopup from "../TransformationFactoryPopup.vue";
import FooterView from "@/views/FooterView.vue";
import { Popover } from "bootstrap";
let SELECT_AT_LEAST_ONE_ITEM = "Select at least one item";

export default {
  name: "ReportTemplate",
  props: [
    "tableProps",
    "projectParamId",
    "xslParamId",
    "xmlParamId",
    "jmsParamId",
    "xsdParamId",
    "configParamId",
    "mapperParamId",
    "apiParamId",
  ],
  emits: ["editableGridUpdated", "toggleTabs"],
  data() {
    return {
      popupData: {
        viewContent: [],
        fileName: "",
      },
      lastSelectedIndex: null,
      projectName: "",
      circumference: 2 * Math.PI * 18, // ~113.1 (for r=18)
      popupCommonData: {},
      popupFileData: [],
      popUpLoading: true,
      currentPageName: "",
      showPopup: false,
      sortColumn: this.getDefaultSortColumn(),
      hoveredColumn: "",
      isDescending: true,
      noRecordFound: false,
      searchName: "",
      searchConcept: "All Categories",
      searchQuery: "",
      tableConfigs: {},
      selectedConfigs: {},
      showCalcPopup: false,
      columns: {
        default: {},
        sort: {},
        search: {},
      },
      files: [],
      filterSortColumn: this.tableProps.defaultSortColumn || "requestDate",
      filterSortOrder: this.tableProps.defaultSortOrder || "desc",
      reportTransactions: { transactions: [] },
      userId: getCookie(user.id),
      loading: true,
      selectedFilter: ["ok", "new", "fail", "in-prog", "NA", "*"],
      refreshReport: {
        interval: 5000,
        autoRefresh: false,
        isAutoRefresh: false,
      },
      selectedColumns: [],
      popup: {},
      selectedReqsForBulkOps: [],
      backupSelections: [],
      currentPage: 1,
      pageSize: 20,
      totalPages: 5, //Just initial value. will be overridden in search() api call
      isMultiSelectionAllowed: false,
      uploadStore: useUploadStore(),
      ellipsesdTextoolTip: null,
      selectAllCheckboxes: false,
      // Add this new property to track selections per page
      selectedReqsByPage: {},
      changes: [],
      editingId: null,
      originalValues: {},
      refinedEditableGridViewColumns: [],
      refinedEditableGridUpdatesToBeEmitted: {},
      totalRecords: 0,
      stateFilter: ["true", "false", "*"],
      states: [
        { name: "true", label: "In-Active" },
        { name: "false", label: "Active" },
      ],
      isGridVisible: true,
      showTransformationFactoryPopup: false,
      useCaseData: [],
      showUseCasePopup: false,
      pendingDownloadRequests: [],
      isSelectAllUsed: false,
      allSelectedReqs: new Set(), // Track all selected IDs globally
    };
  },
  components: {
    ConfirmModal,
    PopupYAML,
    Pagination,
    CalculateComplexityPopup,
    TransformationFactoryPopup,
    Loading,
    FooterView,
  },

  computed: {
    effectiveSelections() {
      if (
        this.showTransformationFactoryPopup &&
        this.backupSelections.length > 0
      ) {
        return this.backupSelections;
      }
      return this.selectedReqsForBulkOps;
    },
    routerParams() {
      return this.$route.params;
    },
    dashOffset() {
      const progress = (100 - this.status.accuracyValue) / 100;
      return this.circumference * progress;
    },
    requestId() {
      // return Store.getters.getRequestId;
      return getSessionItem("requestId");
    },
    computeDateAndTimestamp() {
      return (transaction, column) => {
        return this.convertToLocalTimeAndFormat(transaction[column.name], true);
      };
    },
    computeAccuracy() {
      return (transaction, column) => {
        return this.checkReturnAccuracyValue(transaction, column);
      };
    },
    isRootRoute() {
      // Safely access $route and check the path
      return this.$route && this.$route.path === "/";
    },
    uploadComplete() {
      return this.uploadStore.uploadComplete;
    },
    refinedChanges() {
      const result = this.changes.map((change) => {
        const processedObject = {};
        Object.keys(this.refinedEditableGridViewColumns).forEach((key) => {
          const columnMetadata = this.tableConfigs
            .filter((item) => item.name === key)
            .reduce((acc, curr) => {
              return curr;
            });
          if (key in change) {
            processedObject[this.refinedEditableGridViewColumns[key]] =
              STATUS_COLUMNS.includes(key) && change.hasOwnProperty(key)
                ? CONVERSION_STATUS.getByValue(change[key]).name
                : change[key];
          }
          if (columnMetadata && columnMetadata.traceable) {
            const currentKey = `current_${key}`;
            if (currentKey in change) {
              processedObject[
                `Prior ${this.refinedEditableGridViewColumns[key]}`
              ] =
                STATUS_COLUMNS.includes(key) && change.hasOwnProperty(key)
                  ? CONVERSION_STATUS.getByValue(change[currentKey]).name
                  : change[currentKey];
            } else {
              processedObject[
                `Prior ${this.refinedEditableGridViewColumns[key]}`
              ] =
                STATUS_COLUMNS.includes(key) && change.hasOwnProperty(key)
                  ? CONVERSION_STATUS.getByValue(change[currentKey]).name
                  : change[key];
            }
          }
        });
        return processedObject;
      });
      return result;
    },
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  async mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.getSetConfig();
    this.getPagination();
    this.selectedSort();
    let isViewUpdated = this.tableStore.getTableState(this.$route.name);
    isViewUpdated ? this.copyPropsFromSession() : this.copyProps();
    this.search();
  },
  unmounted() {
    clearInterval(this.refreshReport.isAutoRefresh);
  },
  setup() {
    const sortStore = useSortStore();
    const tableStore = useTableColumnStore();
    const paginationStore = usePaginationStore();
    return { sortStore, tableStore, paginationStore, pageViews, type };
  },

  watch: {
    uploadComplete(uploadStats) {
      if (uploadStats) {
        this.refresh();
        this.search();
        this.uploadStore.setUploadComplete(false);
      }
    },
    selectedReqsForBulkOps: {
      handler(newVal) {
        // Keep selectAllCheckboxes in sync with selection
        if (
          this.reportTransactions &&
          this.reportTransactions.transactions &&
          this.reportTransactions.transactions.length > 0 &&
          this.reportTransactions.transactions.length === newVal.length
        ) {
          this.selectAllCheckboxes =
            newVal.length === this.reportTransactions.transactions.length;
        } else {
          this.selectAllCheckboxes = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    showPopover(e) {
      try {
        const el = e.currentTarget;
        if (!el) return;

        // Dispose any existing popover on the element
        const existing = Popover.getInstance(el);
        if (existing) existing.dispose();

        // Create new popover
        const pop = new Popover(el, {
          trigger: "manual",
          container: "body",
          html: true,
          placement: "top",
        });
        pop.show();

        // Adjust width after showing
        const popoverEl = document.querySelector(".popover");
        if (popoverEl) {
          popoverEl.style.maxWidth = "500px"; // adjust width
          popoverEl.style.whiteSpace = "normal"; // allow wrapping
        }
      } catch (error) {
        console.warn("Popover error (show):", error);
      }
    },

    hidePopover(e) {
      try {
        const el = e.currentTarget;
        if (!el) return;

        const pop = Popover.getInstance(el);
        if (pop) pop.hide();
      } catch (error) {
        console.warn("Popover error (hide):", error);
      }
    },

    handleClickOutside(event) {
      const excludedTags = new Set(["button", "input"]);

      if (excludedTags.has(event.target.tagName.toLowerCase())) {
        return;
      }

      if (!this.$refs.requestTable?.contains(event.target)) {
        this.selectedReqsForBulkOps = [];
      }
    },
    getPagination() {
      const paginationStore = this.paginationStore.getPaginationState(
        this.$route.name
      );
      if (paginationStore) {
        this.currentPage = paginationStore.currentPage;
        this.pageSize = paginationStore.pageSize;
      }
    },
    isSortable(column) {
      return column?.isSortable !== false;
    },
    toggleTabs() {
      this.$emit("toggleTabs");
    },
    getDefaultSortColumn() {
      const colOrder = this.tableProps.configs.find((item) => item.order === 1);
      return colOrder
        ? colOrder.name
        : this.tableProps.configs[0]
        ? this.tableProps.configs[0].name
        : "";
    },
    setShowPop(value) {
      this.showPopup = value;
    },
    collateRequestIDs(requestId) {
      if (this.$parent.$options.name == pageViews.TRASHVIEW) {
        this.selectedReqsForBulkOps = [requestId];
        this.allSelectedReqs = new Set([requestId]);
      } else {
        const index = this.selectedReqsForBulkOps.indexOf(requestId);
        if (index > -1) {
          this.selectedReqsForBulkOps.splice(index, 1);
          this.allSelectedReqs.delete(requestId);
        } else {
          this.isSelectAllUsed = false;
          this.selectedReqsForBulkOps.push(requestId);
          this.allSelectedReqs.add(requestId);
        }
      }
    },
    updateSelectAllCheckboxes() {
      // Update per-page selection state
      const pageKey = this.currentPage;
      if (!this.selectedReqsByPage) this.selectedReqsByPage = {};
      this.selectedReqsByPage[pageKey] = [...this.selectedReqsForBulkOps];

      this.selectAllCheckboxes =
        this.reportTransactions &&
        this.reportTransactions.transactions &&
        this.reportTransactions.transactions.length > 0 &&
        this.reportTransactions.transactions.length ===
          this.selectedReqsForBulkOps.length;
    },
    toggleSelectAllCheckboxes() {
      const pageKey = this.currentPage;
      if (this.selectAllCheckboxes) {
        // Track that "select all" was used
        this.isSelectAllUsed = true;
        // Select all visible records and add to global selection
        const ids = this.reportTransactions.transactions.map((txn) =>
          this.getUniqueIDValue(txn)
        );
        this.selectedReqsForBulkOps = ids;
        ids.forEach((id) => this.allSelectedReqs.add(id));
      } else {
        // When deselecting all, reset the flag
        this.isSelectAllUsed = false;
        // Deselect all visible records, but keep others selected
        const ids = this.reportTransactions.transactions.map((txn) =>
          this.getUniqueIDValue(txn)
        );
        this.selectedReqsForBulkOps = [];
        ids.forEach((id) => this.allSelectedReqs.delete(id));
      }
      // Save selection for this page
      this.selectedReqsByPage[pageKey] = [...this.selectedReqsForBulkOps];
    },
    setType(type) {
      setSessionItem("type", type);
    },
    checkReturnAccuracyValue(transaction, column) {
      let tooltip_suffix = "% accurate";
      if (
        STATUS_COLUMNS.includes(column.name) &&
        transaction.hasOwnProperty(ACCURACY_COLUMNS_STATUS_MAP[column.name])
      ) {
        return (
          transaction[ACCURACY_COLUMNS_STATUS_MAP[column.name]] + tooltip_suffix
        );
      }
    },
    checkIfDateColumn(column) {
      if (DATE_COLUMNS.includes(column.name)) return true;
      return false;
    },
    checkIfEditable(column) {
      return column.isEditable && column.dropdownOptions;
    },
    checkIfActionable(transaction, column) {
      const actionableStatus = [CONVERSION_STATUS.OK.value];
      /* const actionableStatus = [CONVERSION_STATUS.OK.value, CONVERSION_STATUS.PROGRESS.value, CONVERSION_STATUS.NA.value, CONVERSION_STATUS.FAIL.value]; */
      if (column.actionable && column.routeTo)
        if (
          STATUS_COLUMNS.includes(column.name) &&
          transaction.hasOwnProperty(column.name) &&
          actionableStatus.includes(transaction[column.name])
        )
          return true;
      return false;
    },
    getStylesForStatus(transaction, column, isActionable) {
      const allStatus = [
        CONVERSION_STATUS.OK.value,
        CONVERSION_STATUS.PROGRESS.value,
        CONVERSION_STATUS.NA.value,
        CONVERSION_STATUS.FAIL.value,
        CONVERSION_STATUS.NEW.value,
        CONVERSION_STATUS.TRUE.value,
        CONVERSION_STATUS.FALSE.value,
      ];
      if (
        STATUS_COLUMNS.includes(column.name) &&
        transaction.hasOwnProperty(column.name) &&
        allStatus.includes(transaction[column.name].toString())
      ) {
        if (
          CONVERSION_STATUS.getByValue(transaction[column.name]) ==
          CONVERSION_STATUS.OK
        ) {
          return isActionable
            ? "badge badge-success actionable"
            : "badge badge-success";
        } else if (
          CONVERSION_STATUS.getByValue(transaction[column.name]) ==
          CONVERSION_STATUS.PROGRESS
        ) {
          return isActionable
            ? "badge badge-progress actionable blink"
            : "badge badge-progress blink";
        } else if (
          CONVERSION_STATUS.getByValue(transaction[column.name]) ==
          CONVERSION_STATUS.NA
        ) {
          return isActionable ? "badge badge-na actionable" : "badge badge-na";
        } else if (
          CONVERSION_STATUS.getByValue(transaction[column.name]) ==
          CONVERSION_STATUS.FAIL
        ) {
          return isActionable
            ? "badge badge-danger actionable"
            : "badge badge-danger";
        } else if (
          CONVERSION_STATUS.getByValue(transaction[column.name]) ==
          CONVERSION_STATUS.NEW
        ) {
          return isActionable
            ? "badge badge-new actionable"
            : "badge badge-new";
        } else if (
          CONVERSION_STATUS.getByValue(transaction[column.name]) ==
          CONVERSION_STATUS.TRUE
        ) {
          return isActionable
            ? "badge badge-legality actionable"
            : "badge badge-legality";
        } else if (
          CONVERSION_STATUS.getByValue(transaction[column.name]) ==
          CONVERSION_STATUS.FALSE
        ) {
          return isActionable
            ? "badge badge-subscription actionable"
            : "badge badge-subscription";
        }
      }
      return;
    },
    getSingleRecordCenterClass(transaction, column) {
      if (
        column.name === "customFunctionList" &&
        this.reportTransactions &&
        this.reportTransactions.transactions &&
        this.reportTransactions.transactions.length === 1
      ) {
        const data = this.getTableData(transaction, column);
        if (data && data !== "-" && !data.includes(",")) {
          return "single-record-center";
        }
      }
      return "";
    },
    getTextAlignmentStyle(transaction, column) {
      let myStyle;

      if (column.textAlign && column.textOverflowStyle) {
        myStyle = `text-align:${column.textAlign};white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 250px;`;
      } else if (column.textAlign) {
        myStyle = `text-align:${column.textAlign};`;
      } else if (column.textOverflowStyle) {
        myStyle = `white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 250px;`;
      }

      if (
        String(transaction.usecaseNames).split(",").length > 1 &&
        column.name === "fileName"
      ) {
        return `text-decoration: underline green;${myStyle}`;
      } else {
        return myStyle;
      }
      return;
    },
    getTextOverflowStyle(transaction, column) {
      return column.textOverflowStyle
        ? `white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; display: inline-block`
        : "";
    },
    handleMouseEnterForEllipsedText(event, transaction, column) {
      const target = event.target;
      if (column.textOverflowStyle && target.scrollWidth > target.clientWidth) {
        const textContent = target.innerText;
        const rect = target.getBoundingClientRect();
        this.ellipsesdTextoolTip = document.createElement("div");
        this.ellipsesdTextoolTip.className = "custom-ellipsed-text-tooltip";
        this.ellipsesdTextoolTip.innerText = textContent;
        document.body.appendChild(this.ellipsesdTextoolTip);
        this.ellipsesdTextoolTip.style.top = `${
          rect.top + window.scrollY - this.ellipsesdTextoolTip.offsetHeight - 5
        }px`;
        this.ellipsesdTextoolTip.style.left = `${rect.left + window.scrollX}px`;
      }
    },
    hidleEllipsedTextTooltip(event) {
      if (this.ellipsesdTextoolTip) {
        document.body.removeChild(this.ellipsesdTextoolTip);
        this.ellipsesdTextoolTip = null;
      }
    },
    checkToShowTrash(viewName) {
      if (viewName == pageViews.ALLINONE_ACC_VIEW) return true;
      return false;
    },
    setInitialPageToOne(view) {
      this.paginationStore.savePaginationState(view, this.pageSize, 1);
    },
    handleActionableColumns(transaction, column) {
      this.setInitialPageToOne(pageViews.KAFKACONFIGGENERATORVIEW);
      this.setInitialPageToOne(pageViews.SCHEMACONVERTERVIEW);
      this.setInitialPageToOne(pageViews.CONVERTERVIEW);
      this.setInitialPageToOne(pageViews.CONNECTOR_CONFIG_GENERATOR_VIEW);
      this.setInitialPageToOne(pageViews.MAPPERVIEW);
      this.setInitialPageToOne(pageViews.APIVIEW);
      this.redirectView(column.routeTo, transaction);
    },
    handleUseCaseClick(transaction) {
      if (transaction.usecaseNames && transaction.usecaseNames.length > 0) {
        // Handle both array and string formats
        let useCases = [];
        if (Array.isArray(transaction.usecaseNames)) {
          useCases = transaction.usecaseNames;
        } else if (typeof transaction.usecaseNames === "string") {
          useCases = transaction.usecaseNames
            .split(",")
            .map((uc) => uc.trim())
            .filter(Boolean);
        }

        this.useCaseData = useCases.map((uc) => ({
          useCase: uc,
          usecaseIds: transaction.usecaseIds || "N/A",
        }));
      } else {
        this.useCaseData = [];
      }
      this.showUseCasePopup = true;
    },
    isDownloadToBeDisabled(transaction) {
      const matchingStatusColumns = STATUS_COLUMNS.filter((key) =>
        transaction.hasOwnProperty(key)
      );
      let statusToBeChecked = [];
      if ([type.KAFKA, type.PROJECT].includes(this.tableProps.type)) {
        statusToBeChecked = [CONVERSION_STATUS.OK.value];
      } else {
        statusToBeChecked = [
          CONVERSION_STATUS.OK.value,
          CONVERSION_STATUS.NA.value,
          CONVERSION_STATUS.FAIL.value,
          CONVERSION_STATUS.PROGRESS.value,
        ];
      }
      const atleastOnePassed = matchingStatusColumns
        .map((key) => transaction[key])
        .some((element) => statusToBeChecked.includes(element));
      return !atleastOnePassed;
    },
    isViewToBeDisabled(transaction) {
      const matchingStatusColumns = STATUS_COLUMNS.filter((key) =>
        transaction.hasOwnProperty(key)
      );
      let statusToBeChecked = [];
      if ([type.KAFKA].includes(this.tableProps.type)) {
        statusToBeChecked = [CONVERSION_STATUS.OK.value];
      } else {
        statusToBeChecked = [
          CONVERSION_STATUS.OK.value,
          CONVERSION_STATUS.NA.value,
          CONVERSION_STATUS.FAIL.value,
          CONVERSION_STATUS.PROGRESS.value,
        ];
      }
      const atleastOnePassed = matchingStatusColumns
        .map((key) => transaction[key])
        .some((element) => statusToBeChecked.includes(element));
      return !atleastOnePassed;
    },
    isViewMapperToBeDisabled(transaction) {
      const matchingStatusColumns = STATUS_COLUMNS.filter((key) =>
        transaction.hasOwnProperty(key)
      );
      let statusToBeChecked = [];
      if ([type.MAPPER].includes(this.tableProps.type)) {
        statusToBeChecked = [CONVERSION_STATUS.OK.value];
      } else {
        statusToBeChecked = [
          CONVERSION_STATUS.OK.value,
          CONVERSION_STATUS.NA.value,
          CONVERSION_STATUS.FAIL.value,
          CONVERSION_STATUS.PROGRESS.value,
        ];
      }
      const atleastOnePassed = matchingStatusColumns
        .map((key) => transaction[key])
        .some((element) => statusToBeChecked.includes(element));
      return !atleastOnePassed;
    },
    isXMLTransformToBeDisabled(transaction) {
      const matchingStatusColumns = STATUS_COLUMNS.filter((key) =>
        transaction.hasOwnProperty(key)
      );
      let statusToBeChecked = [
        CONVERSION_STATUS.OK.value,
        CONVERSION_STATUS.NA.value,
        CONVERSION_STATUS.FAIL.value,
        CONVERSION_STATUS.PROGRESS.value,
      ];
      const atleastOnePassed = matchingStatusColumns
        .map((key) => transaction[key])
        .some((element) => statusToBeChecked.includes(element));
      return !atleastOnePassed;
    },
    handleInputs(event) {
      if (!event.target.value) {
        this.search();
      }
    },

    getSetConfig() {
      //const config = require("../../public/config.json");
      this.refreshReport.autoRefresh = window.acclConfigs.AUTO_REFRESH;
      this.refreshReport.interval = window.acclConfigs.REFRESH_INTERVAL;
    },

    selectedSort() {
      const savedState = this.sortStore.getSortState(this.$route.name);
      if (savedState) {
        this.filterSortOrder = savedState.sortOrder;
        this.filterSortColumn = savedState.sortColumn;
        this.sortColumn = savedState.sortColumn;
        this.isDescending = savedState.sortOrder === "desc" ? true : false;
      } else {
        this.sortColumn = this.getDefaultSortColumn();
      }
    },

    sort(header, index) {
      this.currentPageName = this.$route.name;

      if (this.isDescending) {
        this.sortAscending(header, index);
      } else {
        this.sortDescending(header, index);
      }
    },
    clearSort() {
      this.sortColumn = this.getDefaultSortColumn();
      this.filterSortColumn = this.tableProps.defaultSortColumn
        ? this.tableProps.defaultSortColumn
        : "requestDate";
      this.filterSortOrder = this.tableProps.defaultSortOrder
        ? this.tableProps.defaultSortOrder
        : "desc";
    },

    sortAscending(header, index) {
      this.sortColumn = header.name;
      this.isDescending = false;
      this.filterSortOrder = "asc";
      this.handleSortByChange(header);
      this.sortStore.saveSortState(
        this.currentPageName,
        this.filterSortOrder,
        this.filterSortColumn,
        index
      );
    },

    sortDescending(header, index) {
      this.sortColumn = header.name;
      this.isDescending = true;
      this.filterSortOrder = "desc";
      this.handleSortByChange(header);
      this.sortStore.saveSortState(
        this.currentPageName,
        this.filterSortOrder,
        this.filterSortColumn,
        index
      );
    },
    clearFilters() {
      this.selectedFilter = ["*", "ok", "new", "fail", "in-prog", "NA"];
      this.stateFilter = ["true", "false", "*"];
      this.copyProps();
      this.searchName = "";
      this.searchConcept = "All Categories";
      this.searchQuery = "";
      this.clearSort();
      this.clearUpdatedViews();
      this.search();
    },
    clearUpdatedViews() {
      removeSessionItem(this.tableProps.type + "_columns");
      removeSessionItem(this.tableProps.type + "_view_updated");
    },
    setSearchFilter(filter) {
      if (filter == "All Categories") {
        this.searchConcept = filter;
      } else {
        this.searchConcept = filter.label;
      }
      this.searchName = filter.name;
    },
    openModalFromCalc(data) {
      this.popup = data;
      this.openModal();
    },
    openModal() {
      this.$refs.openModalBox.openModal();
    },
    resolveDropDownSelectionKey(selectedValue, cloumn) {
      if (STATUS_COLUMNS.includes(cloumn.name)) {
        let dropdownKey = CONVERSION_STATUS.getByName(selectedValue);
        return dropdownKey.value;
      } else {
        return selectedValue;
      }
    },

    isSingleUsecase(usecaseNames) {
      if (String(usecaseNames).split(",").length == 1) {
        return true;
      } else {
        return false;
      }
    },

    getUsecaseNames(usecaseNames) {
      if (!usecaseNames) return "No Usecase Available";

      return String(usecaseNames)
        .split(",")
        .map((u, i) => i + 1 + ". " + u.trim())
        .join("<br><br>");
    },
    getTableData(record, column) {
      if (column.formatter) {
        return column.formatter(record[column.name]);
      }

      if (column.name === "accelatorStatus") {
        return this.getStatusColumns(record)
          .map(({ icon, statusValue, accuracyValue }) => {
            return `<img src="${icon}" alt="status" style="width: 25px; height: 25px;" /> - ${statusValue} (${accuracyValue}%)`;
          })
          .join(", ");
      }

      let value = record[column.name];
      if (
        STATUS_COLUMNS.includes(column.name) &&
        record.hasOwnProperty(column.name)
      ) {
        let conv_status = CONVERSION_STATUS.getByValue(record[column.name]);
        value = conv_status.name;
      }

      if (column.type == "date") {
        value = this.convertToLocalTimeAndFormat(value, false);
      } else if (column.suffix && value != undefined) {
        value = value + column.suffix;
      } else if (value == undefined) {
        value = "-";
      }

      return value;
    },

    setValuesToSession(componentType, userId, requestId, convertedFileName) {
      setSessionItem("userId", userId);
      componentType === type.XML
        ? setSessionItem("xmlrequestId", requestId)
        : setSessionItem("xslRequestIds", requestId);
      setSessionItem("convertedFileName", convertedFileName);
      setSessionItem("componentType", componentType);
      if (componentType === type.XSL) {
        setSessionItem("xslFileName", convertedFileName);
      }
    },

    copyProps() {
      this.tableConfigs = [...this.tableProps.configs].sort(
        (a, b) => a.order - b.order
      );
      this.addUserColumnIfAdmin();
      this.selectedConfigs = this.tableConfigs.filter(
        (column) => column.defaultSelected
      );

      this.selectedColumns = this.selectedConfigs.map((column) => column.name);
      this.columns.search = this.tableConfigs
        .filter((item) => item.search != false)
        .map(({ name, label }) => ({ name, label }));

      this.isMultiSelectionAllowed = this.tableProps.isMultiSelectionAllowed;
    },

    copyPropsFromSession() {
      this.tableConfigs = [...this.tableProps.configs].sort(
        (a, b) => a.order - b.order
      );
      this.addUserColumnIfAdmin();
      this.selectedConfigs = this.tableStore.getTableState(this.$route.name);
      this.selectedColumns = this.selectedConfigs.map((column) => column.name);

      if (this.selectedColumns?.length === this.tableConfigs?.length) {
        this.selectedColumns.push("*");
      }

      this.columns.search = this.tableConfigs
        .filter((item) => item.search != false)
        .map(({ name, label }) => ({ name, label }));

      this.isMultiSelectionAllowed = this.tableProps.isMultiSelectionAllowed;
    },
    addUserColumnIfAdmin() {
      let userRole = getCookie(user.role);
      if (
        [role.admin, role.superadmin].includes(userRole) &&
        this.tableProps.type != type.USER_ROLES &&
        this.tableProps.type != type.ORCHESTRATION
      ) {
        let userObj = {
          name: "userId",
          label: "User ID",
          order: 0,
          defaultSelected: true,
          textAlign: "left",
        };
        this.tableConfigs.unshift(userObj);
      }
    },
    handleSortByChange(header) {
      this.filterSortColumn = header.name;
      this.search();
    },
    convertToLocalTimeAndFormat(databaseDateString, appendTimeStamp) {
      // Handle null, undefined, or empty values
      if (
        !databaseDateString ||
        databaseDateString === null ||
        databaseDateString === undefined
      ) {
        return "-";
      }

      const dateObject = new Date(databaseDateString);

      // Check if the date is invalid
      if (isNaN(dateObject.getTime())) {
        return "-";
      }

      // Convert to local time
      const localDateObject = new Date(
        dateObject.getTime() - dateObject.getTimezoneOffset() * 60000
      );
      return this.formatDate(localDateObject, appendTimeStamp);
    },
    formatDate(dateTimeString, appendTimeStamp) {
      let dateDelimiter = "/";
      const dateObject = new Date(dateTimeString);
      let formattedDate = `${this.formatTwoDigits(
        dateObject.getMonth() + 1
      )}${dateDelimiter}${this.formatTwoDigits(
        dateObject.getDate()
      )}${dateDelimiter}${dateObject.getFullYear()}`;

      if (appendTimeStamp) {
        formattedDate =
          formattedDate +
          ` ${this.formatTwoDigits(
            dateObject.getHours()
          )}:${this.formatTwoDigits(
            dateObject.getMinutes()
          )}:${this.formatTwoDigits(dateObject.getSeconds())}`;
      }
      return formattedDate;
    },
    formatTwoDigits(value) {
      return value.toString().padStart(2, "0");
    },
    confirmDelete(incomingData) {
      let data = {
        userId: incomingData.userId,
        action: action.DELETE,
        type: incomingData.fileType,
        requestId: [incomingData.requestId],
      };
      this.setConfirmModalValues(
        `Are you sure you want to delete ?`,
        incomingData.fileName,
        "Delete",
        "Cancel",
        data
      );
      this.openModal();
    },
    confirmDeleteAll(incomingData) {
      const filenames = this.reportTransactions.transactions
        .filter((item) => incomingData.includes(item.projectId)) // Find objects with matching IDs
        .map((item) => item.fileName); // Extract filenames

      let data = {
        userId: getCookie(user.id),
        action: action.DELETE,
        type: this.tableProps.type,
        requestId: incomingData,
      };
      this.setConfirmModalValues(
        `Are you sure you want to delete the following file(s) ?`,
        filenames,
        "Delete",
        "Cancel",
        data
      );
      this.openModal();
    },
    setConfirmModalValues(
      title,
      body,
      actionLabel,
      secondaryActionLabel,
      data
    ) {
      const confirmModalData = {
        title,
        body,
        actionLabel,
        secondaryActionLabel,
        data,
      };
      this.popup = { ...confirmModalData };
    },

    handleColumnChange(value) {
      if (value === "*") {
        if (this.selectedColumns?.length === this.tableConfigs?.length) {
          this.selectedColumns = this.tableConfigs
            .filter((column) => column.checked)
            .map((item) => item.name);
        } else if (
          this.selectedColumns?.length <=
          this.tableConfigs?.length - 2
        ) {
          this.selectedColumns = this.tableConfigs.map(
            (column) => column?.name
          );
          this.selectedColumns.push("*");
        }
      }
      if (value !== "*") {
        this.selectedColumns = this.selectedColumns.filter(
          (selectedColumn) => selectedColumn !== "*"
        );
      }

      this.selectedValidColumns = this.selectedColumns.filter(
        (column) => column !== "*"
      );

      this.selectedConfigs = this.tableConfigs.filter((column) =>
        this.selectedColumns.includes(column.name)
      );
      this.tableStore.saveTableState(this.$route.name, this.selectedConfigs);
      this.search();
    },
    handleStateChange(value) {
      if (value === "*") {
        if (this.stateFilter.length === 0) {
          this.stateFilter.push("false");
        } else if (
          this.stateFilter?.length === this.states?.length &&
          !this.stateFilter.includes("*")
        ) {
          this.stateFilter = this.states
            .filter((item) => item.name == "false")
            .map((item) => item.name);
        } else {
          this.stateFilter = this.states?.map((status) => status.name);
          this.stateFilter.push("*");
        }
      } else {
        this.stateFilter = this.stateFilter.filter(
          (statusFilter) => statusFilter !== "*"
        );
        if (
          this.stateFilter?.length === this.states?.length &&
          !this.stateFilter.includes("*")
        ) {
          this.stateFilter.push("*");
        }
      }
      this.search();
    },
    handleStatusChange(value) {
      if (value === "*") {
        if (this.selectedFilter.length === 0) {
          this.selectedFilter.push("ok");
        }

        if (this.selectedFilter?.length === this.$statuses?.length) {
          this.selectedFilter = this.$statuses
            .filter((item) => item.name == "ok")
            .map((item) => item.name);
        } else {
          this.selectedFilter = this.$statuses?.map((status) => status.name);
          this.selectedFilter.push("*");
        }
      } else {
        this.selectedFilter = this.selectedFilter.filter(
          (statusFilter) => statusFilter !== "*"
        );
        if (
          this.selectedFilter?.length === this.$statuses?.length &&
          !this.selectedFilter.includes("*")
        ) {
          this.selectedFilter.push("*");
        }
      }
      this.search();
    },
    hardShowLoading(message) {
      return toast.loading(message, {
        autoClose: false,
        closeOnClick: false,
      });
    },
    showSuccess(message) {
      return toast.success(message, {
        autoClose: 3000,
      });
    },
    showError(message) {
      toast.error(message, {
        autoClose: 3000,
      });
    },

    handlePrimaryAction(data) {
      if (data.action) {
        if (data.action === action.DELETE) {
          this.deleteRecord(data);
        } else if (data.action === action.REPLACE) {
          this.restoreRecord(data);
        } else if (data.action === action.REMOVE_CALC_ROW) {
          this.$refs.removeRowRef.removeRow(data);
        }
      }
    },
    async bulkDelete(reqIdArr) {
      this.confirmDeleteAll(reqIdArr);
    },
    async deleteRecord(data) {
      let body = {
        userId: data.userId,
        type: data.type,
        requestIds: data.requestId,
      };

      try {
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/delete",
          body
        );
        if (response.status === 200) {
          this.search();
          this.showSuccess(response.data.message);
        } else {
          this.showError(response.data.message);
        }
      } catch (error) {
        console.error("Delete failed:", error);
      } finally {
        this.selectedReqsForBulkOps = [];
      }
    },
    async restore(restoreType, selectedReqsForBulkOps) {
      const requestIds = this.reportTransactions.transactions
        .filter((txn) =>
          selectedReqsForBulkOps.includes(this.getUniqueIDValue(txn))
        )
        .map((txn) => this.getUniqueIDValue(txn));
      if (requestIds.length === 0) return;

      const transaction = this.reportTransactions.transactions.find(
        (txn) => this.getUniqueIDValue(txn) === requestIds[0]
      );
      const fileName = transaction.fileName;

      let checkFileReqBody = {
        userId: this.userId,
        fileName: fileName,
      };

      try {
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/checkfile",
          checkFileReqBody
        );
        if (response.status === 200) {
          const availableFiles =
            restoreType == type.PROJECT
              ? [response.data]
              : response.data.availableFiles;
          const isDeleteFile = availableFiles[0].isDeleted;
          if (isDeleteFile === false) {
            let data = {
              userId: this.userId,
              action: action.REPLACE,
              type: restoreType,
              requestId: requestIds,
            };
            this.setConfirmModalValues(
              "Restore Confirmation",
              "The file already exists. Are you sure you want to restore ?",
              "Restore",
              "Cancel",
              data
            );
            this.openModal();
          } else if (isDeleteFile === true) {
            let data = {
              userId: this.userId,
              type: restoreType,
              requestId: requestIds,
            };
            this.restoreRecord(data);
          }
        }
      } catch (error) {
        if (error.status == 404) {
          let data = {
            userId: this.userId,
            type: restoreType,
            requestId: requestIds,
          };
          this.restoreRecord(data);
        } else {
          console.error("Error making api call", error);
        }
      }
    },
    async restoreRecord(data) {
      let body = {
        userId: data.userId,
        type: data.type,
        requestIds: data.requestId,
      };
      try {
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/restore",
          body
        );
        if (response.status === 200) {
          this.search();
          this.showSuccess(response.data.message);
        } else {
          this.showError(response.data.message);
        }
      } catch (error) {
        console.error("restore failed:", error);
      }
    },
    removeInvalidBEColumns(targetArray) {
      return targetArray.filter(
        (element) => !elementsToRemoveFromArray.includes(element)
      );
    },
    addUniqueElements(array, elements) {
      array.push(...elements);
      const uniqueElements = new Set(array);
      return Array.from(uniqueElements);
    },

    async searchWithQuery() {
      this.currentPage = 1;
      await this.search();
    },

    async search() {
      let searchValues = { queryValue: this.searchQuery.trim() };

      if (this.searchName != "") {
        searchValues = { ...searchValues, ...{ queryColumn: this.searchName } };
      }

      let fields = [...this.selectedColumns];
      const filters = this.initializeDefaultFilters();
      fields = this.addUniqueElements(
        fields,
        supportingColumns[this.tableProps.type]
      );
      let invalidColumns = invalidBEColumns[this.tableProps.type];
      fields = fields.filter((column) => !invalidColumns.includes(column));

      this.setFiltersFromRoute(filters);

      let payload = {
        userId: this.userId,
        type: this.tableProps.type,
        fields: fields,
        filters: filters,
        sort: {
          field: this.filterSortColumn,
          order: this.filterSortOrder,
        },
        pagination: {
          page: this.currentPage,
          pageSize: this.pageSize,
        },
      };

      if (searchValues != null) {
        payload = { ...payload, ...searchValues };
      }
      try {
        let response = {};
        if (api_mode == "actual") {
          response = await makeOpearationRequest(
            this.$acclConfigs,
            "/search",
            payload
          );
        } else {
          if (this.tableProps.type == type.SCHEMA) {
            response = mock_response.SCHMEA_SEARCH_API;
          } else if (this.tableProps.type == type.XSL) {
            response = mock_response.XSL_SEARCH_API;
          } else if (this.tableProps.type == type.XML) {
            response = mock_response.XML_SEARCH_API;
          } else if (this.tableProps.type == type.PROJECT) {
            response = mock_response.PROEJCT_SEARCH_API;
          } else if (this.tableProps.type == type.KAFKA) {
            response = mock_response.KAFKA_SEARCH_API;
          } else if (this.tableProps.type == type.USER_ROLES) {
            response = mock_response.USER_ROLES_SEARCH_API;
          } else if (this.tableProps.type == type.DOWNLOADS) {
            response = mock_response.DOWNLOADS_SEARCH_API;
          } else if (this.tableProps.type == type.MAPPER) {
            response = mock_response.USER_ROLES_SEARCH_API;
          } else if (this.tableProps.type == type.API) {
            response = mock_response.API_SEARCH_API;
          } else if (this.tableProps.type == type.ORCHESTRATION) {
            response = mock_response.ORCHESTRATION_SEARCH_API;
          }
        }
        if (response.status == 200 && !response.data.transactions.length) {
          this.noRecordFound = true;
        } else {
          this.noRecordFound = false;
        }
        if (
          response.status == 200 &&
          this.refreshReport.isAutoRefresh == false &&
          this.refreshReport.autoRefresh == true
        ) {
          this.refreshReport.isAutoRefresh = true;
          this.refreshReport.isAutoRefresh = setInterval(() => {
            this.search();
          }, this.refreshReport.interval);
        }
        this.reportTransactions = response.data;
        this.totalRecords = response.data.totalRecords;
        this.totalPages = Math.ceil(response.data.totalRecords / this.pageSize);

        // Reset the select all flag when new data is loaded
        this.isSelectAllUsed = false;
      } catch (error) {
        // Error handling - silenced for production
      } finally {
        this.loading = false;
      }
    },
    initializeDefaultFilters() {
      let filters = [];
      let isDeleteProps = false;
      if (Array.isArray(this.tableProps.filters)) {
        isDeleteProps = this.tableProps.filters.some(
          (filter) => filter.isDeleted === true
        );
      }
      if (this.tableProps.type === type.USER_ROLES) {
        filters =
          this.stateFilter.length >= this.states.length
            ? []
            : this.removeInvalidBEColumns(this.stateFilter).map((item) => ({
                isDisabled: item,
              }));
      } else if (this.tableProps.type === type.DOWNLOADS) {
        // For downloads, exclude isDeleted filter as Downloads table doesn't have this column
        filters = [
          { status: this.removeInvalidBEColumns(this.selectedFilter) },
        ];
      } else {
        filters = [
          { isDeleted: isDeleteProps },
          { status: this.removeInvalidBEColumns(this.selectedFilter) },
        ];
      }
      return filters;
    },
    refresh() {
      this.loading = false;
    },
    getUniqueIDValue(transaction) {
      const fileType = this.tableProps.type;
      return transaction[GRID_ACTION_DATA_ELEMENTS[fileType].requestIdKey];
    },
    getUniqueIDKey() {
      const fileType = this.tableProps.type;
      return GRID_ACTION_DATA_ELEMENTS[fileType].requestIdKey;
    },
    setFiltersFromRoute(existingFilters) {
      const filterMapping = ROUTER_PARAMS_GRID_FILTER_MAP[this.tableProps.type];
      if (!filterMapping) {
        return existingFilters;
      }
      for (const [paramKey, filterKey] of Object.entries(filterMapping)) {
        const paramValue = this.routerParams[paramKey];
        if (paramValue) {
          const index = existingFilters.findIndex((item) => filterKey in item);
          if (index !== -1) {
            // Update existing filter
            existingFilters.splice(index, 1, { [filterKey]: paramValue });
          } else {
            // Add new filter
            existingFilters.push({ [filterKey]: paramValue });
          }
        }
      }
      return existingFilters;
    },

    async bulkViewYAMLFile(requestIds) {
      const actions = this.tableProps.actions;
      const fileType = this.tableProps.type;
      const popupTitle = actions?.view?.popupTitle;
      const filteredFiles = this.reportTransactions.transactions.filter(
        (file) =>
          requestIds.includes(
            file[GRID_ACTION_DATA_ELEMENTS[fileType].requestIdKey]
          )
      );

      const { userId, projectId } = filteredFiles[0];

      this.popupFileData = {
        files: filteredFiles.map((file) => ({
          requestId: file[GRID_ACTION_DATA_ELEMENTS[fileType].requestIdKey],
          fileName: file.fileName || file.xsdName,
        })),
        userId,
        projectId,
        popupTitle,
        fileType,
      };
      this.showPopup = true;
      const titleResponse = await getTitle(
        this.$acclConfigs,
        this.popupFileData.projectId,
        this.userId,
        "project"
      );
      this.projectName = titleResponse.data.title;
    },

    async viewYAMLFile(data, userId) {
      try {
        this.popupData = {};
        this.showPopup = true;
        this.popUpLoading = true;

        let payload = {
          userId: getCookie(user.id),
          type: this.tableProps.type,
          requestId: data.requestId,
        };
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/view",
          payload
        );
        if (response.status === 200) {
          this.popupData.viewContent = response.data.data.sort(
            (a, b) => a.order - b.order
          ); // Sort by order
          this.popupData.fileName = data.fileName;
          this.popUpLoading = false;
        }
      } catch (error) {
        console.error("Failed to fetch YAML:", error);
      }
    },
    async bulkDownload(reqIdArr) {
      let data = {
        userId: getCookie(user.id),
        fileType: this.tableProps.type,
        requestId: reqIdArr,
      };
      if (this.tableProps.type === type.XSL) {
        if (reqIdArr.length === 1) {
          this.backupSelections = [...this.selectedReqsForBulkOps];
          this.showTransformationFactoryPopup = true;
          this.pendingDownloadRequests = reqIdArr;
          return;
        } else {
          data.tfRequired = "no";
        }
      }
      this.download(data, true);
      this.selectedReqsForBulkOps = [];
      this.allSelectedReqs.clear();
    },
    handleTransformationFactoryChoice(choice) {
      this.showTransformationFactoryPopup = false;
      const { type } = this.tableProps;
      const data = {
        userId: getCookie(user.id),
        fileType: type,
        requestId: this.pendingDownloadRequests,
        tfRequired: choice,
      };
      this.download(data, true);
      this.pendingDownloadRequests = [];
      this.backupSelections = [];
      this.selectedReqsForBulkOps = [];
      this.allSelectedReqs.clear();
    },
    async download(data, isBulk) {
      window.dispatchEvent(new Event("hide-tooltips"));
      let toastId = null;
      let payload;
      let endpoint;

      // Set default endpoint for all tables
      endpoint = "/download";

      // Handle Downloads table with different payload format and endpoint
      if (data.fileType === type.DOWNLOADS) {
        // For Downloads table: use download_url endpoint with binary_name payload
        const requestId = isBulk ? data.requestId[0] : data.requestId;
        const transaction = this.reportTransactions.transactions.find(
          (txn) => this.getUniqueIDValue(txn) === requestId
        );

        payload = {
          userId: data.userId,
          type: "download_url",
          binary_name: transaction?.binaryName,
        };

        endpoint = "/download_url"; // Override endpoint specifically for Downloads
      } else {
        // For all other tables: use original format with default endpoint
        payload = {
          userId: data.userId,
          type: data.fileType,
          requestIds: isBulk ? data.requestId : [data.requestId],
        };

        // Add tfRequired parameter if it exists in the data
        if (data.tfRequired) {
          payload.tfRequired = data.tfRequired;
        }
      }

      // Change config to handle JSON response for async downloads
      let config = {
        responseType: "json", // Changed from "blob" to handle JSON response
      };

      try {
        toastId = this.hardShowLoading("Submitting download request...");
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          endpoint, // Use dynamic endpoint (/download_url for Downloads, /download for others)
          payload,
          config
        );

        if (response.status === 202) {
          // Handle async download request accepted

          toast.update(toastId, {
            render: `${
              response.data.message ||
              "Download request accepted. Processing started."
            }`,
            type: "info",
            isLoading: false,
            autoClose: 4000,
          });

          // Show additional success message
          this.showSuccess(
            `Request submitted successfully! ` +
              `Check the Downloads page to monitor progress and download when ready.`
          );
        } else if (response.status === 200) {
          // Handle immediate download (fallback for backward compatibility)

          // Check if response is a blob (direct download), URL string, or JSON (async)
          if (response.data instanceof Blob) {
            // Handle direct file download
            toast.update(toastId, {
              render: "File downloaded successfully.",
              type: "success",
              isLoading: false,
              autoClose: 2000,
            });

            const blob = new Blob([response.data], {
              type: response.data.type,
            });
            // Retrieve the fileName
            let fileName = data.fileName;
            const contentDisposition =
              response.headers.get("content-disposition") ||
              response.headers.get("Content-Disposition");
            if (contentDisposition) {
              const fileNameMatch =
                contentDisposition.match(/filename="?(.+)"?/);
              if (fileNameMatch.length > 1) {
                fileName = fileNameMatch[1];
              }
            }
            fileName = fileName ?? "Migrated-Projects";
            // Create a link element and trigger the download
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = changeFileExtension(fileName, "zip");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          } else if (
            typeof response.data === "string" &&
            response.data.startsWith("http")
          ) {
            // Handle pre-signed URL response - directly navigate to URL for download

            toast.update(toastId, {
              render: "File downloaded successfully.",
              type: "success",
              isLoading: false,
              autoClose: 2000,
            });

            // Create a temporary link element and trigger download from pre-signed URL
            const a = document.createElement("a");
            a.href = response.data;
            a.target = "_blank"; // Open in new tab to ensure download
            a.download = ""; // Let browser determine filename from URL/headers
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } else {
            // Handle JSON response for immediate processing
            toast.update(toastId, {
              render: "Download request processed successfully.",
              type: "success",
              isLoading: false,
              autoClose: 3000,
            });

            this.showSuccess(
              `Download processed successfully! ` +
                `Check the Downloads page to access your file.`
            );
          }
        } else {
          console.error("Unexpected response status:", response.status);
          if (toastId != null) {
            toast.update(toastId, {
              render: "Download request failed",
              type: "error",
              autoClose: 3000,
              isLoading: false,
            });
          }
          this.showError("Download Failed");
        }
      } catch (error) {
        if (toastId != null) {
          toast.update(toastId, {
            render: "Download request failed",
            type: "error",
            autoClose: 3000,
            isLoading: false,
          });
        }
        this.showError("Download Failed");
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async xmlShowDiff(requestId) {
      const type = this.tableProps.type;
      const requestIdsObj = this.reportTransactions.transactions
        .filter((file) => requestId.includes(file.xmlId))
        .map(({ xmlId, xmlFileName }) => ({ xmlId, xmlFileName }));

      const data = {
        userId: this.userId,
        requestId: requestIdsObj,
        fileType: type,
      };
      this.setType(type);
      this.setValuesToSession(type, data.userId, data.requestId, "");
      this.$router.push({
        name: pageViews.XML_FILE_DIFFERENCE,
      });
    },

    async xslShowDiff(requestIds) {
      const type = this.tableProps.type;
      const requestIdsObj = this.reportTransactions.transactions
        .filter((file) => requestIds.includes(file.xslId))
        .map(({ xslId, xslFileName }) => ({ xslId, xslFileName }));

      const data = {
        userId: this.userId,
        requestIds: requestIdsObj,
        fileType: type,
        projectId: this.projectId,
      };
      this.setType(type);
      this.setValuesToSession(type, data.userId, data.requestIds, "");
      this.$router.push({
        name: pageViews.XSL_FILE_DIFF,
      });

      //type === type.XML ? this.redirectView(pageViews.XMLFILEDIFFERENCE, data) : this.redirectView(pageViews.FILEDIFFERENCE, data);
    },

    async xmlTransform(comptype, data) {
      this.setValuesToSession(
        comptype,
        data.userId,
        data.requestId,
        data.fileName
      );
      this.redirectView(pageViews.XMLTRANSFORM, data);
    },
    async trashView(type, userId) {
      this.setValuesToSession(type, userId);
      this.redirectView(pageViews.TRASHVIEW, {});
    },
    async redirectView(viewName, txnData) {
      let gridType = this.tableProps.type;
      redirect(
        this.tableProps.type,
        this.$router,
        this.routerParams,
        viewName,
        txnData
      );
    },
    addFile(event) {
      let droppedFiles = Array.from(event.dataTransfer.files);
      if (!droppedFiles) return;
      this.files = this.files.concat(droppedFiles);
    },
    removeFile(file) {
      this.files = this.files.filter((f) => f !== file);
    },

    formatSize(size) {
      return (size / 1024).toFixed(2);
    },
    onPageChange(page) {
      // Save current page's selection before changing page
      this.selectedReqsByPage[this.currentPage] = [
        ...this.selectedReqsForBulkOps,
      ];

      this.selectAllCheckboxes = false;
      // Reset the select all flag when changing pages
      this.isSelectAllUsed = false;
      this.paginationStore.savePaginationState(
        this.$route.name,
        this.pageSize,
        page
      );
      this.currentPage = page;

      // Restore selection for the new page
      const pageKey = page;
      if (this.selectedReqsByPage[pageKey]) {
        this.selectedReqsForBulkOps = [...this.selectedReqsByPage[pageKey]];
      } else {
        this.selectedReqsForBulkOps = [];
      }
      // Set selectAllCheckboxes based on restored selection
      if (
        this.reportTransactions &&
        this.reportTransactions.transactions &&
        this.reportTransactions.transactions.length > 0 &&
        this.selectedReqsForBulkOps.length ===
          this.reportTransactions.transactions.length
      ) {
        this.selectAllCheckboxes = true;
      } else {
        this.selectAllCheckboxes = false;
      }
      this.refresh();
      this.search();
    },
    onRecordChange(recordSize) {
      // Merge all previously selected records from all pages

      // Save current page's selection for persistence
      this.selectedReqsByPage[this.currentPage] = [
        ...this.selectedReqsForBulkOps,
      ];

      // Only update pageSize, keep currentPage as is
      this.pageSize = recordSize;
      this.paginationStore.savePaginationState(
        this.$route.name,
        recordSize,
        this.currentPage
      );

      this.loading = false;
      this.search().then(() => {
        // After search, keep all previously selected records that are still visible
        const visibleIds =
          this.reportTransactions && this.reportTransactions.transactions
            ? this.reportTransactions.transactions.map((txn) =>
                this.getUniqueIDValue(txn)
              )
            : [];
        // After search, update global selection with any visible selections
        this.selectedReqsForBulkOps.forEach((id) =>
          this.allSelectedReqs.add(id)
        );
        // Now, show only those selected that are visible on this page
        this.selectedReqsForBulkOps = visibleIds.filter((id) =>
          this.allSelectedReqs.has(id)
        );
        // Set selectAllCheckboxes if all visible records are selected
        if (
          visibleIds.length > 0 &&
          visibleIds.every((id) => this.selectedReqsForBulkOps.includes(id))
        ) {
          this.selectAllCheckboxes = true;
        } else {
          this.selectAllCheckboxes = false;
        }
      });
    },
    handleClearSelection() {
      // Defensive: still keep this for the event, but main logic is above
      this.selectedReqsForBulkOps = [];
      this.selectAllCheckboxes = false;
      // Also clear for this page
      this.selectedReqsByPage[this.currentPage] = [];
      this.allSelectedReqs.clear();
    },
    startEditing(data, column) {
      const uniqueId = this.getUniqueIDValue(data);
      this.editingId = uniqueId + column.name;
      if (
        !(
          this.originalValues[uniqueId] &&
          this.originalValues[uniqueId].hasOwnProperty(column.name)
        )
      ) {
        if (this.originalValues[uniqueId]) {
          this.originalValues[uniqueId][column.name] = data[column.name];
        } else {
          this.originalValues[uniqueId] = { [column.name]: data[column.name] };
        }
      }
    },
    isEditing(uniqueId, column) {
      return this.editingId === uniqueId + column.name;
    },
    trackChanges(data, column) {
      const uniqueId = this.getUniqueIDValue(data);
      const uniqueIdKey = this.getUniqueIDKey();
      const existingChange = this.changes.find(
        (change) => change[uniqueIdKey] === data[uniqueIdKey]
      );
      const originalValue = this.originalValues[data[uniqueIdKey]]
        ? this.originalValues[data[uniqueIdKey]][column.name]
        : undefined;
      if (data[column.name].toString() !== originalValue.toString()) {
        if (existingChange) {
          if (!existingChange[`current_${column.name}`]) {
            existingChange[`current_${column.name}`] = originalValue.toString();
          }
          existingChange[column.name] = data[column.name];
        } else {
          this.changes.push({
            ...data,
            [`current_${column.name}`]: originalValue.toString(),
          });
        }
      } else {
        this.changes = this.changes
          .map((change) => {
            if (change[uniqueIdKey] === data[uniqueIdKey].toString()) {
              const newChange = { ...change };
              Object.keys(change).forEach((key) => {
                if (
                  key.startsWith("current_") &&
                  key.slice(8) === column.name
                ) {
                  delete newChange[key];
                }
                if (key === column.name) {
                  //delete newChange[key];
                  newChange[key] = data[key];
                }
              });
              return newChange;
            }
            return change;
          })
          .filter((change) => {
            return Object.keys(change).some((key) =>
              key.startsWith("current_")
            );
          });
      }
      this.refinedEditableGridViewColumns =
        EDITABLE_GRID_CHANGES_COLUMNS[this.tableProps.type];
      //this.$emit('editableGridUpdated', this.changes);

      this.refinedEditableGridUpdatesToBeEmitted = {
        originalChanges: this.changes,
        refinedChanges: this.refinedChanges,
      };
      this.$emit(
        "editableGridUpdated",
        this.refinedEditableGridUpdatesToBeEmitted
      );
    },
    discardEditableGridChanges() {
      this.resetEditableGrid();
      this.refresh();
      this.search();
    },
    resetEditableGrid() {
      this.changes = [];
      this.editingId = null;
      this.originalValues = {};
      this.refinedEditableGridViewColumns = [];
      this.refinedEditableGridUpdatesToBeEmitted = {};
    },
    async submitEditableGridChanges() {
      try {
        let payload = this.changes;
        if (
          EDITABLE_GRID_ACTIONS[this.tableProps.type].ingestionEndpoint ===
          "/updateuser"
        ) {
          payload = {
            userId: this.userId,
            changes: this.changes,
          };
        }
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          EDITABLE_GRID_ACTIONS[this.tableProps.type].ingestionEndpoint,
          payload
        );
        if (response.status === 200) {
          this.resetEditableGrid();
          this.refresh();
          this.search();
          this.showSuccess(response.data.message);
        } else {
          this.showError(response.data.message);
        }
      } catch (error) {
        console.error("Update Failed:", error);
        throw error;
      }
    },
    getStatusColumns(record) {
      const statusColumns = [
        {
          icon: require("@/assets/icons/kafka-logo.png"),
          status: "jmsStatus",
          accuracy: "jmsAccuracy",
          routeTo: pageViews.KAFKACONFIGGENERATORVIEW,
          name: "Kafka",
        },
        {
          icon: require("@/assets/icons/Schema.png"),
          status: "schemaStatus",
          accuracy: "schemaAccuracy",
          routeTo: pageViews.SCHEMACONVERTERVIEW,
          name: "Schema",
        },
        {
          icon: require("@/assets/icons/xslticon.png"),
          status: "xslStatus",
          accuracy: "xslAccuracy",
          routeTo: pageViews.CONVERTERVIEW,
          name: "XSLT",
        },
        {
          icon: require("@/assets/icons/Connector.png"),
          status: "connectorStatus",
          accuracy: "connectorAccuracy",
          routeTo: pageViews.CONNECTOR_CONFIG_GENERATOR_VIEW,
          name: "Connector",
        },
        {
          icon: require("@/assets/icons/Mapper.png"),
          status: "mapperStatus",
          accuracy: "mapperAccuracy",
          routeTo: pageViews.MAPPERVIEW,
          name: "Mapping Docs",
        },
        {
          icon: require("@/assets/icons/Api.png"),
          status: "apiStatus",
          accuracy: "apiAccuracy",
          routeTo: pageViews.APIVIEW,
          name: "API",
        },
        // {
        //   icon: require("@/assets/icons/orchestration5.png"),
        //   status: "orchestrationStatus",
        //   accuracy: "orchestrationAccuracy",
        //   routeTo: pageViews.ORCHESTRATION_VIEW,
        //   name: "Orchestration",
        // },
      ];
      return statusColumns.map(({ icon, status, accuracy, routeTo, name }) => {
        const statusValue = record[status]
          ? CONVERSION_STATUS.getByValue(record[status]).name
          : "-";
        const accuracyValue = record[accuracy] ? Number(record[accuracy]) : 0;
        let cssClass = "ok"; // Default green color for OK status
        let strokeDasharray = `${accuracyValue}, 100`; // Default stroke-dasharray for OK status

        if (statusValue === CONVERSION_STATUS.PROGRESS.name) {
          cssClass = "in-prog";
          strokeDasharray = "100, 100"; // Fully filled circle
        } else if (statusValue === CONVERSION_STATUS.NA.name) {
          cssClass = "NA";
          strokeDasharray = "100, 100"; // Fully filled circle
        } else if (statusValue === CONVERSION_STATUS.FAIL.name) {
          cssClass = "fail";
          strokeDasharray = "100, 100"; // Fully filled circle
        } else if (statusValue === CONVERSION_STATUS.NEW.name) {
          cssClass = "new";
          strokeDasharray = "100, 100"; // Fully filled circle
        }
        return {
          icon,
          statusValue,
          accuracyValue,
          routeTo,
          cssClass,
          strokeDasharray,
          name,
          iconStyle:
            statusValue === CONVERSION_STATUS.NA.name
              ? { backgroundColor: "#ccc", cursor: "not-allowed" }
              : {},
        };
      });
    },
    async calculateComplexity() {
      try {
        this.showCalcPopup = true;
        this.popupData.viewTitle = "Complexity Calculation";
      } catch (error) {
        console.error("Failed to fetch YAML:", error);
      }
    },
    getTooltipText(action) {
      if (actionLabel.COMPARE.toLowerCase() == action.toLowerCase()) {
        SELECT_AT_LEAST_ONE_ITEM = "Select at least one item";
      }
      return this.selectedReqsForBulkOps.length === 0
        ? `${SELECT_AT_LEAST_ONE_ITEM} to ${action}`
        : action;
    },
    handleRowClick(event, requestId, index) {
      // Prevent selection if user is highlighting text
      if (window.getSelection().toString()) {
        return;
      }

      if (event.shiftKey && this.lastSelectedIndex !== null) {
        // Get range for shift selection
        let min = Math.min(this.lastSelectedIndex, index);
        let max = Math.max(this.lastSelectedIndex, index);

        // Select all items in the range
        let newSelections = this.reportTransactions.transactions
          .slice(min, max + 1)
          .map((transaction) => this.getUniqueIDValue(transaction));

        // Merge new selections while keeping unique values
        this.selectedReqsForBulkOps = [
          ...new Set([...this.selectedReqsForBulkOps, ...newSelections]),
        ];
      } else if (event.ctrlKey || event.metaKey) {
        this.collateRequestIDs(requestId);
      } else {
        this.selectedReqsForBulkOps = [requestId];
      }
      this.lastSelectedIndex = index;
    },
    async connectorLibrary() {
      const payload = {
        userId: this.userId,
        type: "library",
      };

      let toastId = null; // For showing loading icon
      const config = { responseType: "blob" };

      try {
        toastId = this.hardShowLoading(
          "Hang tight! Your download is on its way.."
        );
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/download",
          payload,
          config
        );

        if (response.status === 200) {
          toast.update(toastId, {
            render: "Connector Library downloaded successfully.",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });

          const blob = new Blob([response.data], { type: response.data.type });
          let fileName = "Connector_library.zip";
          const contentDisposition =
            response.headers.get("content-disposition") ||
            response.headers.get("Content-Disposition");
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch.length > 1) {
              fileName = fileNameMatch[1];
            }
          }

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          console.error("Unexpected response status:", response.status);
          if (toastId != null) {
            toast.update(toastId, {
              render: "Download failed",
              type: "error",
              autoClose: 3000,
              isLoading: false,
            });
          }
          this.showError("Download Failed");
        }
      } catch (error) {
        console.error("Error during library download:", error);
        if (toastId != null) {
          toast.update(toastId, {
            render: "Download failed",
            type: "error",
            autoClose: 3000,
            isLoading: false,
          });
        }
        this.showError("An error occurred while downloading the library.");
      }
    },
    getStatusRouteUrl(transaction, status) {
      // Map status.routeTo to route name and params, You may need to adjust param keys for each accelerator type,Example assumes projectId is always the param
      if (!status.routeTo) return "#";
      try {
        return this.$router.resolve({
          name: status.routeTo,
          params: { projectParamId: transaction.projectId },
        }).href;
      } catch (e) {
        return "#";
      }
    },
    handleStatusIconClick(transaction, status) {
      // Only allow navigation if status is actionable (not Not Applicable)
      if (!["Not Applicable"].includes(status.statusValue) && status.routeTo) {
        this.$router.push({
          name: status.routeTo,
          params: { projectParamId: transaction.projectId },
        });
      }
    },
  },
};
</script>

<style scoped>
/* Modern Container */
.modern-container {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 200px);
  background: var(--body-bg);
  padding: 20px;
  box-sizing: border-box;
}

.table-wrapper {
  background: var(--surface);
  border-radius: 12px;
  box-shadow: 0 1px 3px var(--shadow-strong);
  overflow: hidden;
}

/* Modern Filter Bar */
.modern-filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: var(--surface);
  border-bottom: 1px solid var(--border-color);
  gap: 12px;
  flex-wrap: wrap;
}

.filter-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  flex-wrap: wrap;
}

/* Search Container */
.search-container {
  position: relative;
  flex: 1;
  max-width: 320px;
  min-width: 240px;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
  pointer-events: none;
}

.modern-search-input {
  width: 100%;
  height: 45px;
  padding: 10px 12px 10px 40px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 14px;
  color: var(--text-primary);
  background: var(--surface);
  transition: all 0.2s;
}

.modern-search-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 4px color-mix(in srgb, var(--primary) 15%, transparent);
}

.modern-search-input::placeholder {
  color: var(--text-secondary);
}

/* Filter Buttons */
.filter-btn {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 14px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.filter-btn:hover {
  background: var(--surface-hover);
  border-color: var(--text-secondary);
}

.filter-btn:active {
  background: #f2f4f7;
}

.date-filter-btn {
  min-width: 240px;
}

.date-range-text {
  font-weight: 400;
}

/* Icon Buttons */
.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.icon-btn:hover {
  background: var(--surface-hover);
  color: var(--text-primary);
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}
.reload-btn i {
  transition: transform 0.5s ease-in-out;
}

.reload-btn:hover i {
  transform: rotate(360deg);
}


.action-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
  font-size: 16px;
}

.action-icon-btn:hover:not(:disabled) {
  background: var(--surface-hover);
  color: var(--text-primary);
  border-color: var(--text-secondary);
}

.action-icon-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.action-icon-btn.eye-btn {
  color: var(--success);
  border-color:var(--success);
}

.action-icon-btn.download-btn {
  color: var(--download);
  border-color:var(--download);
}

.action-icon-btn.download-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--download) 10%, var(--surface));
  color: var(--download);
  border-color: var(--download);
}

.action-icon-btn.eye-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--success) 10%, var(--surface));
  color: var(--success);
  border-color: var(--success);
}

.action-icon-btn.compare-btn {
  color: var(--warning);
  border-color:var(--warning);
}

.action-icon-btn.compare-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--warning) 10%, var(--surface));
  color: var(--warning);
  border-color: var(--warning);
}

.action-icon-btn.zip-btn {
  color: var(--zip);
  border-color:var(--zip);
}

.action-icon-btn.zip-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--zip) 10%, var(--surface));
  color: var(--zip);
  border-color: var(--zip);
}

.action-icon-btn.restore-btn {
  color: var(--restore);
  border-color:var(--restore);
}

.action-icon-btn.restore-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--restore) 10%, var(--surface));
  color: var(--restore);
  border-color: var(--restore);
}

.action-icon-btn.calculator-btn {
  color: var(--calculator);
  border-color:var(--calculator);
}

.action-icon-btn.calculator-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--calculator) 10%, var(--surface));
  color: var(--calculator);
  border-color: var(--calculator);
}

.action-icon-btn.delete-btn {
  color: var(--trash);
  border-color: var(--trash);
}

.action-icon-btn.delete-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--trash) 10%, var(--surface));
  color: var(--trash);
  border-color: var(--trash);
}

/* Modern Dropdown */
.modern-dropdown {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  box-shadow: 0 4px 6px -2px rgba(16, 24, 40, 0.03),
    0 12px 16px -4px rgba(16, 24, 40, 0.08);
  padding: 4px;
  min-width: 200px;
  background: var(--surface);
    inset: auto !important;
  transform: translate(0, 2px) !important;
  position: fixed !important;
  max-height: 400px;
  overflow-y: auto;
  z-index: 9999; 

}

.modern-dropdown .dropdown-item {
  padding: 8px 12px;
  border-radius: 6px;
  color: var(--dropdown-text);
  font-size: 14px;
  transition: background 0.15s;
  background: var(--surface);  
}

.modern-dropdown .dropdown-item:hover {
  background: var(--surface-hover);
    overflow: visible !important;
}

/* Chrome, Edge, Safari */
.modern-dropdown::-webkit-scrollbar {
  width: 2px;
}

.modern-dropdown::-webkit-scrollbar-track {
  background: transparent;
}

.modern-dropdown::-webkit-scrollbar-thumb {
  background: var(--scroll-thumb);
}

.modern-dropdown::-webkit-scrollbar-thumb:hover {
  background: var(--scroll-thumb-hover);
}


.modern-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  cursor: pointer;
  margin: 0;
}

.modern-checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  cursor: pointer;
}

/* Keeps the table visible within the screen */
.modern-table-container {
  /* Default height (for non-root routes) */
  max-height: calc(100vh - 350px);
  overflow-x: auto;
  overflow-y: auto;
  background: var(--surface);
  border: 1px solid var(--border-color);
  box-shadow: 0 1px 3px var(--shadow-soft);
  scroll-behavior: smooth;
}

/* Height specific to the root path '/' */
.modern-table-container.taller-height {
  max-height: calc(100vh - 300px);
}

/* Prevent entire page scroll */
body,
html {
  height: 100%;
  overflow: hidden;
}

/* Keep headers sticky for a nice UX */
.modern-table thead th {
  position: sticky;
  top: 0;
  color: var(--text-secondary);
  z-index: 10;
  background: var(--surface-hover);
  text-transform: uppercase;
  border-bottom: 2px solid var(--border-color);
}

.modern-table {
  width: max-content; /* expands horizontally when new columns are added */
  min-width: 100%; /* ensures no collapse when few columns */
  border-collapse: separate;
  border-spacing: 0;
}

/* Keep headers visible */
.modern-table thead {
  position: sticky;
  top: 0;
  background: #f9fafb;
  z-index: 10;
  border-bottom: 1px solid #eaecf0;
}

.modern-table th {
  padding: 12px 20px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  background: var(--surface-hover);
  border-bottom: 2px solid var(--border-color);
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #eaecf0;
  white-space: nowrap;
  user-select: none;
}

.modern-table th.sortable {
  cursor: pointer;
}

.modern-table th.sortable:hover {
  background: var(--sortable-hover);
}

.th-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px; /* ensures spacing stays consistent */
}

.sort-icon {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 20px; /* fixes width so no shifting */
  height: 25px; /* fixes height so no jumping */
}

.arrow {
  width: 8px;
  height: 8px;
  transition: fill 0.2s ease;
}

.up-arrow {
  margin-bottom: 1px;
}

.down-arrow {
  margin-top: 1px;
}

th.sortable {
  cursor: pointer;
}

th.sortable:hover .arrow {
  fill: var(--text-primary);
}

.modern-table tbody tr {
  border-bottom: 1px solid var(--border-color);
  transition: background 0.15s;
  cursor: pointer;
}

.modern-table tbody tr:hover {
  background: var(--surface-hover);
}

.modern-table tbody tr.selected-row {
  background: var(--primary-hover);
}

.modern-table tbody tr.selected-row:hover {
  background: var(--secondary-hover);
}

.modern-table td {
  padding: 16px 20px;
  font-size: 14px;
  color: var(--text-primary);
  vertical-align: middle;
}

/* Checkbox Column */
.checkbox-column {
  width: 48px;
  text-align: center;
}

.modern-checkbox {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 18px;
  height: 18px;
  border: 1.5px solid #999;
  border-radius: 4px;
  cursor: pointer;
  background-color: var(--surface);
  position: relative;
  transition: all 0.3s ease;
}

.modern-checkbox:checked {
  background-color: #696cff;
  border-color: #696cff;
}

/* The fake tick mark */
.modern-checkbox:checked::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 5px;
  width: 4px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Cell Styles */
.cell-link {
  color: var(--primary);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s;
}

.cell-link:hover {
  color: var(--primary-hover);
  text-decoration: underline;
}

.cell-date {
  color: var(--text-primary);
  font-size: 13px;
}

.cell-text {
  color: var(--text-primary);
}

.text-success {
  color: red;
}

.editable-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-icon {
  width: 16px;
  height: 16px;
  opacity: 0.5;
  cursor: pointer;
  transition: opacity 0.15s;
}

.edit-icon:hover {
  opacity: 1;
}

.modern-select {
  width: 100%;
  height: 36px;
  padding: 6px 12px;
  /* border: 1px solid; */
  border-radius: 6px;
  font-size: 14px;
  color: var(--text-primary);
  background: var(--primary-hover);
  cursor: pointer;
  transition: all 0.2s;
}

.modern-select:focus {
  outline: none;
  border-color: #7f56d9;
  box-shadow: 0 0 0 4px rgba(127, 86, 217, 0.1);
}

.modern-option {
  border: 1px solid var(--border-color);
  font-size: 80px;
  border-radius: 20px;
  /* border-radius: 10%; */
  color: var(--text-primary);
  background: var(--primary-bg);
}

/* === Accelerator Status: Larger Icon + Rounded Progress Bar === */
.status-badges {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.status-badge {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.progress-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 45px;
  width: 45px;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.ring-bg {
  stroke: var(--ring);
}

.ring-progress {
  transition: stroke-dasharray 0.3s ease;
}

.ring-progress.ok {
  stroke: var(--success);
}
.ring-progress.in-prog {
  stroke: var(--warning);
}
.ring-progress.fail {
  stroke: var(--error);
}
.ring-progress.new {
  stroke: var(--info);
}
.ring-progress.NA {
  stroke: var(--NA);
}

/* .ring-border.NA {
  border:1px solid #fff;
  opacity: 0.8;
  padding: 5px;
  height: 45px;
  width: 45px;
  pointer-events: none;
} */

.status-icon-link {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  pointer-events: auto;
}

.status-icon-large {
  width: 30px;
  height: 30px;
  object-fit: contain;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.1));
  transition: transform 0.25s ease; /* ← ADD THIS LINE */
}

/* ADD THESE LINES BELOW */
.status-icon-link:hover .status-icon-large:not(.not-applicable) {
  transform: scale(1.35);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
  transition: all 0.25s ease;
}

.status-badge:hover {
  transform: translateY(-1px);
}

.status-icon-large.not-applicable {
  filter: grayscale(100%) opacity(0.5);
  cursor: not-allowed;
}

.status-icon-large.in-progress {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* No Records */
.no-records {
  padding: 60px 20px !important;
  text-align: center;
  color: var(--text-secondary);
}

.no-records-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.no-records-content p {
  margin: 0;
  font-size: 16px;
  color: var(--text-secondary);
  font-weight: 500;
}

/* Pagination */
.modern-pagination {
  padding: 11px 15px;
  border-top: 1px solid var(--border-color);
  background: var(--surface);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .filter-controls {
    flex-wrap: wrap;
  }

  .search-container {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .modern-filter-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-controls,
  .action-buttons {
    width: 100%;
  }

  .action-buttons {
    justify-content: flex-end;
  }
}

/* Legacy Support - Keep these for backward compatibility */
.pointer {
  cursor: pointer;
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modern-table tbody tr {
  animation: fadeIn 0.3s ease-out;
}

.modern-table-container::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.modern-table-container::-webkit-scrollbar-track {
  background: var(--scroll-track);
}

.modern-table-container::-webkit-scrollbar-thumb {
  background: var(--scroll-thumb);
  transition: background 0.3s ease;
}

.modern-table-container::-webkit-scrollbar-thumb:hover {
  background: var(--scroll-thumb-hover);
}

.search-bar-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Dropdown */
.filter-dropdown {
  background: var(--primary);
  color: #fff;
  border: 1px solid;
  border-color: var(--border-color);
  border-radius: 8px;
  padding: 6px 14px;
  font-weight: 500;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.filter-dropdown:hover,
.filter-dropdown:focus {
  background: var(--primary-hover);
  color: #dfdfdf;
}

/* Search box */
.search-container {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #667085;
}

.modern-search-input {
  height: 40px;
  width: 100%;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 6px 12px 6px 34px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.modern-search-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);
}

/* Search button */
.search-btn {
  border-radius: 8px;
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  color: var(--primary);
  background: var(--surface);
  border: 1px solid var(--primary);
  transition: all 0.2s ease;
}

.search-btn:hover {
  color: #fff;
  background: var(--primary);
  border-color: #fff;
}

/* Clear button */
.clear-btn {
  border-radius: 8px;
  height: 36px;
  width: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-icon {
  width: 18px;
  height: 18px;
  filter: brightness(0) saturate(100%) invert(12%) sepia(7%) saturate(1264%)
    hue-rotate(177deg) brightness(94%) contrast(90%);
  transition: filter 0.2s ease;
}

.clear-btn:hover .filter-icon {
  filter: brightness(0) saturate(100%) invert(39%) sepia(87%) saturate(3211%)
    hue-rotate(9deg) brightness(96%) contrast(97%);
}

/* === Modern Scrollbar Style === */
.badge {
  display: inline-block;
  padding: 4px 7px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-align: center;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(8px);
  transition: all 0.25s ease;
}

/* --- Status Types --- */
.badge-success {
  color: var(--badge-success-text);
  background: var(--badge-success);
}

.badge-danger {
  color: var(--badge-failed-text);
  background: var(--badge-failed);
}

.badge-progress {
  color: var(--badge-progress-text);
  background: var(--badge-progress);
}

.badge-na {
  color: #5f6368;
  background: linear-gradient(90deg, #f1f3f4 0%, #f1f3f4 100%);
}

.badge-new {
  color: var(--badge-new-text);
  background: var(--badge-new);
}

/* Gradient versions (for “Legality” and “Subscription” look) */
.badge-legality {
  background: var(--badge-legality);
  color: var(--badge-legality-text);
}

.badge-subscription {
  background: var(--badge-subscription);
  color: var(--badge-subscription-text);
}

/* --- Interaction Effects --- */
.badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.actionable {
  cursor: pointer;
}

/* --- Blink Animation (for active ones) --- */
.blink {
  animation: softBlink 1.5s infinite;
}

@keyframes softBlink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}
</style>
